// extracted by mini-css-extract-plugin
module.exports = {"main":"FormPlatron_main__QzNii","buttonSubmit":"FormPlatron_buttonSubmit__1hBuw"};